import { createSelector } from 'reselect';
import Immutable from 'immutable';
import { getUGCByType, getSingularUGCByUsers, getUGCByBibs } from './UGCBaseSelector';

const getTransactions = state => state.getIn(['ugc', 'commentsTransactions'], Immutable.Map());

export const getComments = getUGCByType('comments');
export const getCommentsByUsers = getSingularUGCByUsers('comments');
export const getCommentsByBibs = getUGCByBibs('comments');

export const getCommentsTransactions = createSelector([getTransactions], (transactions) => transactions);

export default {
  getComments,
  getCommentsByUsers,
  getCommentsByBibs,
  getCommentsTransactions
};



// WEBPACK FOOTER //
// ./app/selectors/ugc/CommentsSelector.js